import React from 'react';
import cs from 'classnames';

import authPageCSS from '~/components/authpage.css';

const messages = {
  bids: 'Sign up or log in to make bids. It’s free!',
};

const values = {
  premium_loads: 'Premium Broker info',
  anonymous_banner: 'more loads',
};

const ValuesText = ({context, defaultTitle}) => (
  values[context]
    ? (<span>
      Want to access <span className={cs('qa-action-reason', authPageCSS.reason)}>
        {values[context]}
      </span>? <br/>
      Sign up or log in - it’s free!
    </span>)
    : (<span>{defaultTitle}</span>)
);

const FormHeader = ({context, defaultTitle}) => (
  <div className={cs(authPageCSS.title, 'qa-action-header')}>
    {messages[context] ? messages[context] : <ValuesText context={context} defaultTitle={defaultTitle}/>}
  </div>
);

export default FormHeader;



// WEBPACK FOOTER //
// ./src/components/user/FormHeader/index.js